import script from "./ReferralCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferralCard.vue?vue&type=script&setup=true&lang=js"

import "./ReferralCard.vue?vue&type=style&index=0&id=5150be8e&scoped=true&lang=css"

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5150be8e"]])

export default __exports__